<template>
  <Popup
    :popup-visible="dialog"
    content-class="extra-filter-popup"
    hide-overlay
    scrollable
    :header-divider="true"
    :footer-divider="true"
    transition="scroll-y-reverse-transition"
    :header-title="'Filter'"
    :primary-label="'Show Results'"
    :secondary-label="'Reset Filters'"
    :primary-footer-handler="eventHandler"
    :secondary-footer-handler="resetFilters"
    @popupEvent="eventHandler"
  >
    <template #custom-content>
      <v-card-text class="pa-3">
        <slot></slot>
      </v-card-text>
    </template>
  </Popup>
</template>

<script>
import Popup from '@/components/base/Popup/Popup.vue';
import BrandsEnum from '@shared/enums/BrandsEnum.mjs';

export default {
  name: 'ExtraFiltersPopup',
  components: {
    Popup
  },
  props: {
    isDifficultyVisible: {
      type: Boolean,
      default: true
    },
    showGenres: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: true,
      panel: [0, 1, 2, 3, 4]
    };
  },
  computed: {
    isOcean() {
      return this.$store.getters['ContextStore/brand'] === BrandsEnum.OCEAN;
    }
  },
  mounted() {
    this.dialog = true;
  },
  methods: {
    resetFilters() {
      this.dialog = false;
      this.$emit('reset');
    },
    eventHandler() {
      this.dialog = false;
      this.$emit('close');
    }
  }
};
</script>

<style lang="less">
.extra-filter-popup {
  .v-card {
    .v-card__text {
      padding-inline-start: 0;
      padding-inline-end: 0;
    }
  }

  .v-expansion-panel-header {
    font-size: 1em;
  }

  .v-expansion-panel-header {
    font-weight: 700;
  }

  .v-slider__thumb-label {
    font-size: 1em;
  }

  .difficulty-block {
    font-weight: 500;
  }

  .difficulty-label {
    font-size: 10px;
  }
}
</style>
